function switchToSwatch(tappedSwatch) {
    const colorPickerGroup = $(tappedSwatch).parent(); // ul.color-picker

    if (
        colorPickerGroup.parent().attr('class').indexOf('filter-dropdown') > -1 ||
        $(tappedSwatch).parent('#color-picker-modal').length
    ) {
        return; // Filtering dropdown - clicks are handled separtely
    }

    const previousSwatch = $(colorPickerGroup).find('li.selectedColor');

    const newColor = $(tappedSwatch).attr('class').split(' ')[0];

    previousSwatch.removeClass('selectedColor');
    const previousColor = previousSwatch.attr('class').split(' ')[0];
    $(tappedSwatch).addClass('selectedColor');

    previousSwatch.find('button').attr('aria-label', `Switch to ${previousColor}`);
    $(tappedSwatch).find('button').attr('aria-label', `Currently selected color - ${newColor}`);

    const imgKey = $(tappedSwatch).data('imgid');

    const targetImg = $('body').find(`div.hero .primary-image#${$(tappedSwatch).data('target')}`);

    const targetImgData = jQuery.parseJSON(targetImg.attr('data-imgs'));

    if ($(targetImg)) {
        $(targetImg).attr('src', targetImgData[imgKey]);
    }

    if ($(tappedSwatch).data('price') !== undefined) {
        if (Electro.language === 'fr') {
            const frenchPrice = $(tappedSwatch).data('price').toString().replace('.', ',');
            // Handles change on Category pages.
            $(colorPickerGroup).parent().find('span.price').text(`${frenchPrice} $`);

            // Handles change on PDP pages.
            $('.product-info span.price').text(`${frenchPrice} $`);
        } else {
            // Handles change on Category pages.
            $(colorPickerGroup)
                .parent()
                .find('span.price')
                .text(`$${$(tappedSwatch).data('price')}`);

            // Handles change on PDP pages.
            $('.product-info span.price').text(`$${$(tappedSwatch).data('price')}`);
        }
    }

    if ($(tappedSwatch).data('upc') !== undefined) {
        window.selectedProductUPC = $(tappedSwatch).data('upc');
        // console.info('window.selectedProductUPC: ', window.selectedProductUPC);
    }

    const pdpLinks = $(colorPickerGroup).parent().find('a');

    if (pdpLinks.length > 0) {
        for (let i = 0; i < pdpLinks.length; i += 1) {
            // look for nearby PDP links that need the selected color
            if (
                ($(pdpLinks[i]).attr('id') && $(pdpLinks[i]).attr('id').indexOf('pw-') > -1) ||
                ($(pdpLinks[i]).attr('id') && $(pdpLinks[i]).attr('id').indexOf('review') > -1)
            ) {
                // continue; // avoid social sharing icons
            } else if ($(pdpLinks[i]).attr('id') && $(pdpLinks[i]).attr('href').indexOf('/products/') > 0) {
                const href = $(pdpLinks[i]).attr('href').split('#')[0];
                $(pdpLinks[i]).attr('href', `${href}#${newColor}`);
            }
        }
    }

    if ($('div.interactive-thumbs').length) {
        // PDP has interactive thumbs and hero images to hide and show
        $('body').find(`div.interactive-thumbs img.${previousColor}`).parent().hide();
        $('body').find(`div.interactive-thumbs img.${newColor}`).parent().show();
        $('div.interactive-thumbs ul').find('li').removeClass('shownFullsize');
        $('div.interactive-thumbs ul').find('li:visible:first').addClass('shownFullsize');
        $('.curated-review').removeClass('foo').removeAttr('style');
        $('.primary-image').removeClass('zoom');
        $('.primary-image').show();
    }
}

// Load the full-size primary-image corresponding to the tapped thumbnail
function showImgForThumbnail(tappedThumbnail) {
    if ($(tappedThumbnail).hasClass('quote-thumb')) {
        $('.primary-image').hide();
        $('.curated-review').css('display', 'flex').addClass('foo');
    } else if ($(tappedThumbnail).hasClass('video-thumb')) {
        return; // bootstrap.js will open the modal automatically
    } else {
        const imgKey = $(tappedThumbnail).find('img').data('imgid');
        // var targetImg = $('body').find('div.hero .primary-image#' + $(tappedThumbnail).find('img').data('target'));  --modified var...this was breaking the image swatch
        const targetImg = $('body').find('div.hero .primary-image');

        $('.primary-image').show();
        $('.primary-image').removeClass('zoom');

        if ($(window).width() < 769) {
            $('.curated-review').hide().removeClass('foo');
        }
        // eslint-disable-next-line no-console
        console.log(targetImg.data('imgs')[0]);
        $(targetImg).attr('src', targetImg.data('imgs')[imgKey]);
    }

    // Change which tumbnail is selected
    $('body').find('li.shownFullsize').removeClass('shownFullsize');
    $(tappedThumbnail).addClass('shownFullsize');
}

// Add handlers for desktop clicks and mobile taps
$(document).ready(() => {
    if (window.location.hash.length > 0) {
        const hashColor = window.location.hash.substr(1, window.location.hash.length - 1);

        const swatch = $('body').find(`.color-picker li.${hashColor}`);

        if (swatch.length) {
            switchToSwatch(swatch);
        }
    }

    $(window).resize(() => {
        if ($('.curated-review').hasClass('foo') && $(window).width() > 768) {
            showImgForThumbnail($('div.interactive-thumbs ul').find('li:visible:first'));
            $('.curated-review').removeClass('foo').removeAttr('style');
        } else {
            $('.curated-review').removeAttr('style');
        }
    });

    // Desktop handler for color picker swatch clicks
    $(document).on('click', '.color-picker li', (e) => {
        e.preventDefault();
        switchToSwatch(this);
    });

    // Touchscreen handler for color picker swatch taps
    $(document).on('touchstart', '.color-picker li', () => {
        switchToSwatch(this);
    });

    // Desktop handler for interactive thumb clicks
    $(document).on('click', '.interactive-thumbs li', () => {
        showImgForThumbnail(this);
    });

    // Touchscreen handler for interactive thumb taps
    $(document).on('touchstart', '.interactive-thumbs li', () => {
        showImgForThumbnail(this);
    });
});
